/**
 * TUT-586a — o "O que fazer" de cada aviso do pacote padrão, o texto que o
 * dono aprovou na prévia (`docs/design/tut-586-prototipo-notificacoes.html`,
 * a coluna "Proposto"). Ele não depende de dado do evento, então mora aqui e
 * vale também para os avisos já gravados.
 *
 * A TUT-586c reescreve o TÍTULO e o CORPO das regras com os dados do evento;
 * se o corpo novo passar a dizer o que fazer, esta tabela sai junto, senão o
 * aviso repete a frase.
 */
const O_QUE_FAZER: Readonly<Record<string, string>> = {
  "deadline.assigned": "Confira a data e comece a preparar.",
  "deadline.due_soon": "Se não der tempo, peça mais prazo ou reatribua.",
  "deadline.overdue": "Registre a entrega ou informe o novo prazo.",
  "expertise.created": "Confirme o perito e envie a convocação.",
  "expertise.rescheduled": "Avise o perito e o representante local da nova data.",
  "expertise.cancelled": "Libere a agenda do perito e avise o cliente.",
  "expertise.frustrated": "Registre a ocorrência e peça nova data ao juízo, se couber.",
  "expert_report.review_requested": "Aprove ou devolva com comentários.",
  "expert_report.protocol_requested": "Protocole no tribunal e anexe o comprovante.",
  "expert_report.assigned": "Abra e veja o que já foi escrito.",
  "document.upload_rejected": "Envie outra versão do arquivo.",
};

export function oQueFazer(eventKey: string): string | null {
  return O_QUE_FAZER[eventKey] ?? null;
}
